<template>
  <AppLayout>
    <VFlex xs12>
      <ContractsTable>
        <VBtn
          color="primary"
          flat
          @click="$router.push({name: 'contractCreate'})"
        >
          {{ $nt('createContract') }}
        </VBtn>
      </ContractsTable>
    </VFlex>
  </AppLayout>
</template>

<script>
import ContractsTable from '@/components/routes/agentContracts/ContractsTable'
export default {
  name: 'AgentContracts',
  components: { ContractsTable }
}
</script>

<style scoped>

</style>
